<template>
  <div>
    <van-cell is-link title="修改手机号" icon="phone-o" @click="goToSetphone()"/>
    <van-cell is-link title="修改密码" icon="closed-eye" @click="goToSetpassword()"/>
    <div class="q_center q_mar_t30px">
      <van-button class="q_btn_min" round color="#FF5733" @click="goToSign()">退出登录</van-button>
    </div>
  </div>
</template>

<script>
import {Dialog} from "vant";
import store from "@/store";
import {wxCloseShare} from "@/utils/jiutang";

export default {
  name: 'Setup',
  props: {
    msg: String
  },
  data() {
    return {}
  },
  created() {
    wxCloseShare()
  },
  methods: {
    goToSign() {
      Dialog.confirm({
        title: '提示', message: '确定要退出登录吗', confirmButtonText: '退出登录', cancelButtonText: '取消'
      }).then(() => {
        store.dispatch('LogOut').then(() => {
          // location.href = '/h5/mine/sign'
          location.href = '/mine/sign'
        })
      }).catch(() => {
      });
    },
    goToSetphone() {
      this.$router.push({
        path: '/mine/Setphone'
      });
    },
    goToSetpassword() {
      this.$router.push({
        path: '/mine/Setpassword'
      });
    },
  },
}
</script>
<style>
.q_btn_min {
  width: 200px;
}
</style>
